import type { CreateLicense } from '@wf-coe/types';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';
import type { LicenseDto } from './use-licenses.js';

interface CreateLicenseInput {
  clientId: string;
  body: CreateLicense;
}

/** Mutation for `POST /v1/clients/{clientId}/licenses`. */
export function useCreateLicenseMutation(): UseMutationResult<
  LicenseDto,
  Error,
  CreateLicenseInput
> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, body }: CreateLicenseInput) => {
      if (!api) throw new Error('useCreateLicenseMutation: api client unavailable');
      return api.post<LicenseDto>(`/v1/clients/${clientId}/licenses`, body);
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['licenses', clientId] });
    },
  });
}
